import { createApp } from 'vue';
import axios from 'axios';
import App from './App.vue';
import router from './router';
import './index.css'; // Import Tailwind CSS

// Token expired/invalid di mana pun -> paksa re-login sekali, jangan biarkan
// halaman tetap terbuka dengan token mati (mis. save GR gagal 401 diam-diam).
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const isExchange = (error.config?.url || '').includes('/auth/sso/exchange');
    if (error.response?.status === 401 && !isExchange && router.currentRoute.value.path !== '/login') {
      localStorage.removeItem('token');
      router.push({ path: '/login', query: { expired: 1 } });
    }
    return Promise.reject(error);
  }
);

createApp(App).use(router).mount('#app');
